// extracted by mini-css-extract-plugin
module.exports = {"bannerImageOverlay":"style_bannerImageOverlay__EbO47","bannerTitulo":"style_bannerTitulo__133yP","sectionStyle":"style_sectionStyle__o78lF"};